import { render, staticRenderFns } from "./TopBarControl.global.vue?vue&type=template&id=4a6146fa&lang=pug&"
import script from "./TopBarControl.global.vue?vue&type=script&lang=ts&"
export * from "./TopBarControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports